/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionTier } from './SubscriptionTier';
import {
    SubscriptionTierFromJSON,
    SubscriptionTierFromJSONTyped,
    SubscriptionTierToJSON,
    SubscriptionTierToJSONTyped,
} from './SubscriptionTier';

/**
 * 
 * @export
 * @interface SetUserTierRequest
 */
export interface SetUserTierRequest {
    /**
     * 
     * @type {string}
     * @memberof SetUserTierRequest
     */
    user_auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof SetUserTierRequest
     */
    group_name: string;
    /**
     * 
     * @type {SubscriptionTier}
     * @memberof SetUserTierRequest
     */
    tier: SubscriptionTier;
    /**
     * 
     * @type {string}
     * @memberof SetUserTierRequest
     */
    target_org_code?: string | null;
}



/**
 * Check if a given object implements the SetUserTierRequest interface.
 */
export function instanceOfSetUserTierRequest(value: object): value is SetUserTierRequest {
    if (!('user_auth_id' in value) || value['user_auth_id'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('tier' in value) || value['tier'] === undefined) return false;
    return true;
}

export function SetUserTierRequestFromJSON(json: any): SetUserTierRequest {
    return SetUserTierRequestFromJSONTyped(json, false);
}

export function SetUserTierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserTierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_auth_id': json['user_auth_id'],
        'group_name': json['group_name'],
        'tier': SubscriptionTierFromJSON(json['tier']),
        'target_org_code': json['target_org_code'] == null ? undefined : json['target_org_code'],
    };
}

export function SetUserTierRequestToJSON(json: any): SetUserTierRequest {
    return SetUserTierRequestToJSONTyped(json, false);
}

export function SetUserTierRequestToJSONTyped(value?: SetUserTierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_auth_id': value['user_auth_id'],
        'group_name': value['group_name'],
        'tier': SubscriptionTierToJSON(value['tier']),
        'target_org_code': value['target_org_code'],
    };
}

